<template>
  <v-dialog
    id="confirm-dialog"
    ref="confirmDialog"
    @input="!toggleConfirm && resolveConfirm()"
    v-model="toggleConfirm"
    width="500">
    <v-card>
      <v-card-title
        class="headline px-2 py-2"
        primary-title
        v-if="confirmTitle"
        v-html="confirmTitle">
      </v-card-title>

      <div v-html="confirmMsg" class="px-2 pb-2"></div>

      <v-card-actions>
        <div
          v-if="suppressID">
          <v-checkbox
            id="suppress"
            name="suppress"
            ref="suppress"
            class="m-0"
            label="Don't show this message again"
            height="28"
            v-model="suppress">
          </v-checkbox>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          type="button"
          color="primary"
          @click="handleSuppress(); resolveConfirm(true);">
          Yes
        </v-btn>

        <v-btn
          type="button"
          class="ml-3"
          color="primary"
          outlined
          @click="handleSuppress(); resolveConfirm(false);">
          No
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      confirmTitle: '',
      confirmMsg: '',
      toggleConfirm: false,
      suppressID: null,
      suppress: false,
    };
  },
  methods: {
    handleSuppress() {
      if (this.suppress) {
        localStorage.setItem(`rsec.suppressedDialogs.${this.suppressID}`, JSON.stringify(true));
      }
    },
    resolveConfirm(accept) {
      // emit event
      this.$root.$emit('hide-confirm', accept);

      // clear data
      this.toggleConfirm = false;
      this.confirmTitle = '';
      this.confirmMsg = '';
      this.suppressID = null;
      this.suppress = false;
    },
  },
  created() {
    this.$root.$on('show-confirm', (data) => {
      const isSuppressed = JSON.parse(localStorage.getItem(`rsec.suppressedDialogs.${data.suppressID}`));
      if (!isSuppressed) {
        this.toggleConfirm = true;
        this.confirmTitle = data.title;
        this.confirmMsg = data.msg;
        this.suppressID = data.suppressID;
      }
    });
  },
};
</script>

<style lang="scss">
.no-title {
  .dialog {
    .dialog-header {
      padding-top: .25rem;
      padding-bottom: .35rem;
      padding-right: .4rem;
    }
  }
}
</style>
